<template>
    <div>
        <Leftmenu />
        <Header />
        <div v-show="is_answer_confirm" class="answer-confirm-bg"></div>
        <div v-show="is_answer_confirm" class="answer-confirm">
            <span style="font-size: 20px">Благодарим!</span> <br><br>
            Ваша заявка принята! Мы с Вами обязательно свяжемся<br><br>
            <router-link to="/account">Личный кабинет</router-link>
        </div>
        <div class="content">
            <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
            <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
            <div class="content-header">Пройдите опрос</div>
                <div class="quiz_wrapper">
                    <div class="header-for-input">Является ли Ваше предприятие / компания участником национального проекта "Производительность труда"?</div>
                    <select class="content-input" v-model="quizAnswers.is_company_competitor">
                        <option value="false">Нет</option>
                        <option value="true">Да</option>
                    </select>

                    <div class="header-for-input">Какую продукцию (услуги) выпускает (оказывает) Ваше предприятие/компания?</div>
                    <textarea class="content-input content-input-textarea" v-model="quizAnswers.products" size="20"></textarea>

                    <div class="header-for-input">Какая на текущий момент у Вас есть проблема/задача/вызов в рамках развития вашего предприятия (кадровая, производственная, инвестиционная)?</div>
                    <textarea class="content-input content-input-textarea" v-model="quizAnswers.problems" size="20"></textarea>


                    <div class="header-for-input">Какие актуальные группы должностей требуют на текущий момент реализации программ обучения (развития компетенций)?</div>
                    <textarea class="content-input content-input-textarea" v-model="quizAnswers.dolgnost" size="20"></textarea>


                    <div class="header-for-input">Есть ли у Вас собственный учебный центр или центр дуального образования на базе колледжа-партнера?</div>
                    <select class="content-input" v-model="quizAnswers.is_learning_center_have">
                        <option value="false">Нет</option>
                        <option value="true">Да</option>
                    </select>

                    <div class="header-for-input">Готовы ли Вы создать внутри предприятия рабочую группу (команду Корпоративного центра опережающей подготовки) для реализации целей и задач проекта?</div>
                    <select class="content-input" v-model="quizAnswers.is_ready_work_group_create">
                        <option value="false">Нет</option>
                        <option value="true">Да</option>
                    </select>

                    <div class="header-for-input">Кто предположительно будет лидером Вашей команды (укажите должность)?</div>
                    <textarea class="content-input content-input-textarea" v-model="quizAnswers.leader" size="20"></textarea>


                    <br><br>

                    <div class="btn_main_button buttons_inline" @click="save_get_answers()">Сохранить</div>

                </div>
        </div>
    </div>
</template>

<script>
import Leftmenu from '@/components/leftmenu.vue'
import Header from '@/components/header.vue'
import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'Quiz',
    components: {
        Leftmenu, Header, Success, Error
    },
    data() {
        return {
            quizAnswers: {
                is_company_competitor: false,
                products: '',
                problems: '',
                dolgnost: '',
                is_learning_center_have: false,
                is_ready_work_group_create: false,
                leader: ''
            },
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: false,
            /* common vars */
            is_answer_confirm: false
        }
    },
    methods: {
        get_answers() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.get(process.env.VUE_APP_API_URL + '/api/quiz/answers')
                .then(response => {
                    loader.hide()
                    this.quizAnswers.is_company_competitor = response.data.data.is_company_competitor.answer
                    this.quizAnswers.products = response.data.data.products.answer
                    this.quizAnswers.problems = response.data.data.problems.answer
                    this.quizAnswers.dolgnost = response.data.data.dolgnost.answer
                    this.quizAnswers.is_learning_center_have = response.data.data.is_learning_center_have.answer
                    this.quizAnswers.is_ready_work_group_create = response.data.data.is_ready_work_group_create.answer
                    this.quizAnswers.leader = response.data.data.leader.answer

                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
                });
        },
        save_get_answers() {
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/quiz/answers', {
                is_company_competitor: this.quizAnswers.is_company_competitor,
                products: this.quizAnswers.products,
                problems: this.quizAnswers.problems,
                dolgnost: this.quizAnswers.dolgnost,
                is_learning_center_have: this.quizAnswers.is_learning_center_have,
                is_ready_work_group_create: this.quizAnswers.is_ready_work_group_create,
                leader: this.quizAnswers.leader
            })
                .then( () => {
                    loader.hide()
                    this.get_answers()
                    this.is_answer_confirm = true

                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
                });
        }
    },
    created() {
        this.get_answers()
    }
}
</script>

<style scoped src="./../assets/style/main.css"></style>
<style scoped src="./../assets/style/account.css"></style>
<style scoped src="./../assets/style/buttons.css"></style>
<style scoped>
    .quiz_wrapper {
        width: 50%;
    }
    .content-input-textarea {
        height: 110px !important;
    }
</style>